import { CONTACT_EMAIL } from "@/lib/assets";

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="heading text-2xl text-[#67e8f9] mb-3">{title}</h2>
    <div className="font-rajdhani text-gray-300 text-base leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function CookiePolicy() {
  return (
    <div className="max-w-3xl mx-auto px-5 py-16" data-testid="cookie-policy-page">
      <p className="font-rajdhani uppercase tracking-widest text-xs text-gray-500 mb-2">Legale</p>
      <h1 className="heading text-4xl sm:text-5xl text-white mb-2">Cookie <span className="text-[#67e8f9]">Policy</span></h1>
      <p className="font-rajdhani text-gray-500 text-sm mb-10">Ultimo aggiornamento: giugno 2026</p>

      <Section title="1. Cosa sono i cookie">
        <p>I cookie sono piccoli file di testo che i siti web salvano sul dispositivo dell'utente per
        memorizzare informazioni relative alla navigazione.</p>
      </Section>

      <Section title="2. Cookie utilizzati da questo sito">
        <p>Questo sito ha un approccio minimale e <strong>non utilizza cookie di profilazione né cookie
        pubblicitari o di tracciamento di terze parti</strong>. Vengono impiegati esclusivamente cookie e
        tecnologie tecniche necessarie al funzionamento:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Cookie tecnici / di sessione</strong>: necessari per l'autenticazione all'area dashboard.</li>
          <li><strong>Local Storage</strong>: utilizziamo il local storage del browser per conservare il token
          di accesso (chiave <code className="text-[#67e8f9]">seals_token</code>) e mantenere la sessione dell'amministratore.</li>
        </ul>
      </Section>

      <Section title="3. Cookie di terze parti">
        <p>Il sito può includere contenuti o link a piattaforme esterne (Discord, Instagram, TikTok, Twitch,
        YouTube, Facebook). Tali piattaforme possono impostare propri cookie secondo le rispettive policy,
        sulle quali non abbiamo controllo diretto.</p>
      </Section>

      <Section title="4. Gestione dei cookie">
        <p>Puoi gestire o eliminare i cookie e il local storage attraverso le impostazioni del tuo browser.
        La disabilitazione dei cookie tecnici potrebbe impedire l'accesso all'area dashboard.</p>
      </Section>

      <Section title="5. Contatti">
        <p>Per qualsiasi domanda sull'uso dei cookie puoi scrivere a <a className="text-[#67e8f9] underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.</p>
      </Section>
    </div>
  );
}
